import React from 'react';
import {Table} from "react-bootstrap";
import Head from "./components/Head";
import Row from "./components/Row";

const FactorsTable = ({factors, params}) => {
    const rows = factors.map(row => <Row data={row} />);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <Head params={params} />
            <tbody>
            {rows}
            </tbody>
        </Table>
    )
}

export default FactorsTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderWinRateConfig/components/FactorsTable/index.js